var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrolltop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2593_1798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9242 22.9281C54.7657 24.4087 54.7657 26.2229 53.9242 27.7035L42.85 47.1873C41.9912 48.6983 40.3871 49.6316 38.6492 49.6316L16.6312 49.6316C14.8933 49.6316 13.2892 48.6983 12.4304 47.1873L1.35624 27.7035C0.514731 26.2229 0.514728 24.4087 1.35624 22.9281L12.4304 3.44432C13.2892 1.93336 14.8933 0.999998 16.6312 0.999998L38.6492 0.999999C40.3871 0.999999 41.9912 1.93336 42.85 3.44432L53.9242 22.9281Z",
    fill: "url(#paint0_linear_2593_1798)",
    fillOpacity: 0.2,
    stroke: "#FFEEED",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3736 13.7915C27.9688 13.3867 27.3125 13.3867 26.9077 13.7915L20.3112 20.388C19.9064 20.7928 19.9064 21.4491 20.3112 21.8539C20.716 22.2586 21.3723 22.2586 21.7771 21.8539L27.6406 15.9903L33.5042 21.8539C33.909 22.2586 34.5653 22.2586 34.9701 21.8539C35.3749 21.4491 35.3749 20.7928 34.9701 20.388L28.3736 13.7915ZM26.6041 14.5244L26.6041 36.0449L28.6772 36.0449L28.6772 14.5244L26.6041 14.5244Z",
    fill: "#FFEEED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2593_1798",
    x: -3.5249,
    y: -3.25,
    width: 62.3301,
    height: 57.1316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2593_1798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2593_1798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2593_1798",
    x1: 39.9351,
    y1: 25.1917,
    x2: 6.97585,
    y2: 24.4574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEED",
    stopOpacity: 0.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolltop);
export default __webpack_public_path__ + "static/media/scrolltop.11aaa880d2d8a4a5797367e83515a14b.svg";
export { ForwardRef as ReactComponent };